"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var getPurchaseEventId = function (purchase) { var _a, _b, _c; return (_c = (_b = (_a = purchase === null || purchase === void 0 ? void 0 : purchase.events) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.id; };
var updatePurchaseItemInList = function (purchase, list, eventIdOverride) {
    var _a;
    var _b;
    var locList = __assign({}, list);
    var offerId = (_b = purchase === null || purchase === void 0 ? void 0 : purchase.offer) === null || _b === void 0 ? void 0 : _b.id;
    var eventId = parseInt(eventIdOverride || getPurchaseEventId(purchase) || '', 10);
    var purchaseId = purchase === null || purchase === void 0 ? void 0 : purchase.id;
    if (offerId && purchaseId && eventId) {
        var offerItem = locList === null || locList === void 0 ? void 0 : locList[offerId];
        var existingItemEventId = parseInt(getPurchaseEventId(offerItem) || '', 10);
        // Update store item if purchase id is greater than last id or if new entry
        if ((existingItemEventId && eventId > existingItemEventId) || !offerItem) {
            locList = __assign(__assign({}, locList), (_a = {}, _a[offerId] = purchase, _a));
        }
    }
    return locList;
};
var reducers = {
    account: api_1.createCustomModuleReducer(__assign(__assign(__assign(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.GET_CUSTOMER_ACCOUNT,
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.customer;
        },
    })), api_1.createApiReducer({
        actionType: constants_1.CREATE_CUSTOMER_PROFILE,
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data.profiles.push((_a = action.payload) === null || _a === void 0 ? void 0 : _a.createProfile);
        },
    })), api_1.createApiReducer({
        actionType: constants_1.UPDATE_CUSTOMER_PROFILE,
        onSuccess: function (draftState, action) {
            var _a, _b;
            var profiles = draftState.data.profiles;
            var index = profiles === null || profiles === void 0 ? void 0 : profiles.findIndex(function (profileItem) { var _a; return profileItem.id === ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.updateProfile.id); });
            if (index > -1) {
                profiles[index] = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.updateProfile;
            }
            else {
                profiles.push((_b = action.payload) === null || _b === void 0 ? void 0 : _b.updateProfile);
            }
        },
    })), api_1.createApiReducer({
        actionType: constants_1.DELETE_CUSTOMER_PROFILE,
        onSuccess: function (draftState, action) {
            var profiles = draftState.data.profiles;
            var id = action.meta.id;
            var index = profiles === null || profiles === void 0 ? void 0 : profiles.findIndex(function (profileItem) { return profileItem.id === id; });
            if (index > -1) {
                profiles.splice(index, 1);
            }
        },
    })), (_a = {}, _a[constants_1.SET_SELECTED_PROFILE] = function (draftState, action) {
        var profile = action.payload.profile;
        draftState.data.profiles = [profile];
    }, _a)), api_1.createApiInitialState({})),
    purchases: api_1.createCustomModuleReducer(__assign(__assign(__assign(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_USER_PURCHASES,
        onSuccess: function (state, action) {
            var _a, _b, _c, _d;
            var customerRes = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.customer;
            var purchaseList = (Array.isArray(customerRes === null || customerRes === void 0 ? void 0 : customerRes.purchases)
                ? customerRes === null || customerRes === void 0 ? void 0 : customerRes.purchases : []).reduce(function (accList, purchase) { return updatePurchaseItemInList(purchase, accList); }, state.data.list);
            state.data.list = purchaseList || {};
            state.data.sinceEventId = (_d = (_c = (_b = customerRes === null || customerRes === void 0 ? void 0 : customerRes.purchaseEvents) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.id;
        },
    })), api_1.createApiReducer({
        actionType: constants_1.PURCHASE_PPV,
        onSuccess: function (state, action) {
            var _a;
            var purchase = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.purchasePayPerView;
            if (purchase) {
                state.data.sinceEventId = getPurchaseEventId(purchase);
                state.data.list = updatePurchaseItemInList(purchase, state.data.list);
                state.data.response = {
                    type: purchase.__typename,
                };
            }
        },
    })), api_1.createApiReducer({
        actionType: constants_1.PURCHASE_TVOD,
        onSuccess: function (state, action) {
            var _a;
            var purchase = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.purchaseTvod;
            if (purchase) {
                state.data.sinceEventId = getPurchaseEventId(purchase);
                state.data.list = updatePurchaseItemInList(purchase, state.data.list);
                state.data.response = {
                    type: purchase.__typename,
                };
            }
        },
    })), api_1.createApiReducer({
        actionType: constants_1.REVERSE_PURCHASE_PPV,
        onSuccess: function (state, action) {
            var _a;
            var purchase = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.reversePurchase;
            if (purchase) {
                state.data.sinceEventId = getPurchaseEventId(purchase);
                state.data.list = updatePurchaseItemInList(purchase, state.data.list);
            }
        },
    })), (_b = {}, _b[constants_1.SET_PURCHASE_NOTIFICATION_BY_ID] = function (state, action) {
        var req = action.payload;
        if (req && (req === null || req === void 0 ? void 0 : req.purchase)) {
            var eventId = req.id;
            state.data.sinceEventId = eventId;
            state.data.list = updatePurchaseItemInList(req.purchase, state.data.list, eventId);
        }
    }, _b[constants_1.CLEAR_PURCHASE_PPV] = function (state) {
        state.data.response = null;
        state.error = null;
    }, _b)), api_1.createApiInitialState({
        list: {},
        sinceEventId: null,
        response: null,
    })),
    selectedProfileId: api_1.createCustomModuleReducer((_c = {},
        _c[constants_1.SET_SELECTED_CUSTOMER_PROFILE_ID] = function (draftState, action) { return action.payload.id; },
        _c), null),
    textTrackStyles: api_1.createCustomModuleReducer((_d = {},
        _d[constants_1.SET_TEXT_TRACK_STYLE] = function (_, action) { return action.payload; },
        _d), {}),
    customerPackagesIds: api_1.createCustomModuleReducer((_e = {},
        _e[constants_1.SET_CUSTOMER_PACKAGES] = function (_, action) { return action.payload; },
        _e), []),
    settingsByProfileId: api_1.createCustomModuleReducer((_f = {},
        _f[constants_1.SET_PLAYER_SETTINGS] = function (state, action) {
            var _a = action.payload, profileId = _a.profileId, settings = _a.settings;
            state[profileId] = state[profileId] || {};
            if (settings.selectedStyle) {
                state[profileId].selectedStyle = settings.selectedStyle;
            }
            if (settings.selectedTextTrack) {
                state[profileId].selectedTextTrack = settings.selectedTextTrack;
            }
            if (settings.selectedAudioTrack) {
                state[profileId].selectedAudioTrack = settings.selectedAudioTrack;
            }
        },
        _f[constants_1.CLEAR_PLAYER_SETTINGS] = function () { return ({}); },
        _f), {}),
};
exports.default = toolkit_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map